import { render, staticRenderFns } from "./AiSegmented.vue?vue&type=template&id=6d70a63e&scoped=true&"
import script from "./AiSegmented.vue?vue&type=script&lang=js&"
export * from "./AiSegmented.vue?vue&type=script&lang=js&"
import style0 from "./AiSegmented.vue?vue&type=style&index=0&id=6d70a63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70a63e",
  null
  
)

export default component.exports